<template>
<v-col cols="12" md="4">
  <v-card-text>
    <v-row dense>
      <v-col cols="12"><span class="subtitle-2">Select Recipients</span></v-col>
      <v-col cols="12">

        <v-text-field outlined label="Search" single-line dense prepend-inner-icon="mdi-magnify"
          :style="{ borderRadius: '15px' }"
          v-model="search"
          :disabled="shouldSendToAll">
        </v-text-field>

      </v-col>
      <v-col cols="12">
        <v-list rounded dense class="overflow-y-auto" color="#F1F1F1" 
          :style="{ height: '300px' }" 
          :disabled="shouldSendToAll">

          <template v-for="(recipient, index) in recipients">
            <v-list-item
              :key="index"
              :disabled="shouldSendToAll">

              <template v-slot:default>

                <v-list-item-action>
                  <v-checkbox color="primary" dense
                    v-model="selectedRecipientsID"
                    :value="recipient.id"
                    @click="selectedReceiver(recipient)"
                    >
                  </v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title> {{recipient.email}}</v-list-item-title>
                </v-list-item-content>

              </template>

            </v-list-item>
          </template>
          
          <infinite-loading spinner="spiral"
            :identifier="infiniteId"
            @infinite="getRecipients">
            
            <template v-slot:no-more></template>
            <template v-slot:no-results>
              <div class="pa-2 text-center">
                <span class="subtitle-2">End of list.</span>
              </div>
            </template>
          </infinite-loading>
          
        </v-list>
      </v-col>
      
      <v-col cols="12" v-if="(selectedUsers.length > 0)">
        <ReceiversList :list="selectedUsers" @removeEmail="removeRecipientEmail" @removeAll="clearReciepients"/>
      </v-col>
    
      <v-col cols="12" v-if="selectedRecipientsID.length <= 0">
        <v-checkbox color="#258BF5" v-model="shouldSendToAll" @click="markSendToAll">
          <template v-slot:label>
            <span :style="{ color: '#258BF5' }">Send to All</span>
          </template>
        </v-checkbox>
      </v-col>
      
    </v-row>
  </v-card-text>
</v-col>
</template>

<script>

import { GET_NOTIFICATION_RECIPIENTS } from "@/views/csr/store/typeDefs/notification";
import ReceiversList from './ReceiversList.vue';

export default {
  name: 'Receivers',
  components: { ReceiversList },
  data() {
    return {
      shouldSendToAll: false,
      search: null,
      recipients: [],
      page: 1,
      selectedRecipientsID: [],
      selectedUsers: [],
      infiniteId: +new Date(),
      searchTimer: null,
    }
  },
  watch: {
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.recipients = [];
        this.infiniteId += 1;
      }, 800);
    },
  },
  methods: {
    async getRecipients($state) {
      const payload = {
        search: this.search,
        page: this.page,
      };
      let gotRecipients = await this.$store.dispatch(
        GET_NOTIFICATION_RECIPIENTS,
        payload
      );

      this.recipients = [...this.recipients, ...gotRecipients];

      if (gotRecipients.length === 15) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    setReceivers (users) {
      users.map((user) => {
        if (user.user != null) {
          this.selectedRecipientsID.push(user.user.id);
          this.selectedUsers.push({ email: user.user.email, id: user.user.id });
        }
      });
    },
    selectedReceiver (recipient) {

      if (this.selectedRecipientsID.indexOf(recipient.id) >= 0) {
        this.selectedUsers.push({ email: recipient.email, id: recipient.id });
      } else {
        this.removeRecipientEmail({user: {email: recipient.email, id: recipient.id}})
      }

      this.$emit('select', {
        receivers: this.selectedRecipientsID
      })
    },
    markSendToAll () {
      this.$emit('sendtoall', {
        sendToAll: this.shouldSendToAll
      })
    },
    clearReciepients () {
      this.selectedRecipientsID = [];
      this.selectedUsers = [];
    },
    removeRecipientEmail ({user}) {
      let index = null;
      this.selectedUsers.map( (row, ind) => {
        if (user.id == row.id) {
          index = ind;
        }
      });

      if (index != null) {
        this.selectedUsers.splice(index, 1);

        let selectedInd = this.selectedRecipientsID.indexOf(user.id);
        if (selectedInd >= 0) {
          this.selectedRecipientsID.splice(selectedInd, 1);
        }
      }
    }
  }

}
</script>